/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const ChevronLeft = (props: any) => (
<svg {...props} xmlns="http://www.w3.org/2000/svg"   viewBox="0 0 32 32" fill="none">
<path d="M18 11L13 15.8588L18 21" stroke="inherit" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>);

export default ChevronLeft;